import { render } from "./detail.vue?vue&type=template&id=9db1190e&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=9db1190e&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9db1190e"],['__file',"src/views/widget/shop/product/detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9db1190e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9db1190e', __exports__)) {
    console.log('reload')
    api.reload('9db1190e', __exports__)
  }
  
  module.hot.accept("./detail.vue?vue&type=template&id=9db1190e&scoped=true", () => {
    console.log('re-render')
    api.rerender('9db1190e', render)
  })

}


export default __exports__